import React from 'react';
import styled from '@emotion/styled';
import { graphql, useStaticQuery } from 'gatsby';
import { createOptionMap } from '../../utilities/misc';

import useUserContext from '../../hooks/use-user-context';
import { rem } from '../../utilities/style';
import { colors } from '../../theme/colors';
import { body } from '../../styles/type';
import { shadow } from '../../styles/box';

import qrCodeImage from '../../images/chinese-qr.png';
import wechatIcon from '../../images/wechat-icon.svg';

import TextRenderer from '../TextRenderer';

const Container = styled.div`
  display: flex;
  padding-top: ${rem(30)};
`;

const QrImage = styled.img`
  ${shadow}
  border-radius: ${rem(10)};
`;

const ContactContainer = styled.div`
  margin-left: ${rem(20)};
  color: ${colors.gray['600']};

  ${({ theme }) => theme.pageOverrides?.includes('Dark Mode') && `
    color: ${colors.gray['400']};
  `}
`;

const ContactText = styled.div`
  ${body.regular}
  margin-bottom: ${rem(8)};
  color: ${colors.blue['800']};
  ${({ theme }) => theme.pageOverrides?.includes('Dark Mode') && `
    color: ${colors.blue['100']};
  `}
`;

const ContactPhone = styled.div`
  ${body.small}
  margin-bottom: ${rem(4)};

  a {
    color: inherit;
  }

  &:hover a {
    text-decoration: underline;
  }
`;

const ContactHours = styled.div`
  ${body.small}
  margin-bottom: ${rem(8)};
`;

const WeChatIcon = styled.img`
  margin-right: ${rem(8)};
`;

const WeChatText = styled.a`
  display: flex;
  align-items: center;
  font-size: ${rem(12)};
`;

const FooterQr = () => {
  const { language } = useUserContext();
  const data = useStaticQuery(graphql`
  query ChineseFooterQr {
    allContentfulOptionSet(filter: {name: {eq: "footer"}}) {
      nodes {
        ...OptionSetFragment
      }
    }
  }
`);

  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);
  const contactText = options['footer.chinese_contact_text'];
  const phoneNumber = options['footer.chinese_phone_number'];

  return (
    <Container>
      <QrImage
        src={qrCodeImage}
        alt="QR Code"
        height="128px"
      />
      <ContactContainer>
        <ContactText>
          <TextRenderer text={contactText} />
        </ContactText>
        <ContactPhone>
          {'电话咨询: '}
          <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
        </ContactPhone>
        <ContactHours>
          工作日: 9:00-17:00
        </ContactHours>
        <WeChatText>
          <WeChatIcon
            src={wechatIcon}
            alt="WeChat"
          />
          关注官方微信公众号
        </WeChatText>
      </ContactContainer>
    </Container>
  );
};

export default FooterQr;
